import BlogShare from '@elem/compBlog/blog-share';
import EfIcon from '@elem/ui/ef-icon';
import EfImg from '@elem/ui/ef-img';
import BlogTimer from 'lowcomp/plugins/blog/common/blog-timer';
import React from 'react';
import BlogBreadcrumb from '../detail-breadcrumb';
import './index.scss';
export default function BlogDetailsTop({ tempData = {}, locale = 'us' }: { tempData: any; locale: string }) {
    const thePage = tempData?.thePage || {};
    const {
        blogTitle,
        blogImgPc,
        blogImgH5,
        authorIcon = 'https://ecoflow-service-eu-cdn.ecoflow.com/configurable/images/1727780593212/EcoFlow%20logo.jpg',
        authorName = 'EcoFlow',
        widthLayout = 'default',
        imgPosition = 'left',
        widthPc = 1200,
        isHideBlogMainImg = 'false',
    } = thePage;
    const compStyle = {
        '--delta-top-widthPc': `${widthPc}px`,
    } as React.CSSProperties;
    const isHideBlogMainImg2 = `${isHideBlogMainImg}`;
    return (
        <div className={`blog-delta-top blog-delta-top-widthLayout-${widthLayout} blog-delta-top-imgPosition-${imgPosition}`} style={compStyle}>
            <BlogBreadcrumb pageModel="blog" title={blogTitle} />
            <h1 className="blog-delta-top-h">{blogTitle}</h1>
            <div className="blog-delta-top-a1">
                <div className="blog-delta-top-author">
                    <EfIcon pc={authorIcon} className="blog-delta-top-author-icon" />
                    <span className="blog-delta-top-author-name">{authorName}</span>
                    <time className="blog-delta-top-author-time" dateTime={tempData?.firstReleaseTime}>
                        - {BlogTimer(tempData?.newFirstReleaseTime || tempData?.firstReleaseTime, locale)}
                    </time>
                </div>
                <div className="blog-delta-top-share">
                    <BlogShare title={blogTitle} />
                </div>
            </div>
            {/* {isHideBlogMainImg2 !== 'true' && !!blogImgPc && (
                <div className="blog-delta-top-img">
                    <EfImg pc={blogImgPc} h5={blogImgH5} />
                </div>
            )} */}
        </div>
    );
}
